import { Link } from "@tanstack/react-router";
import { Mail } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { PublicNavbar } from "@/components/public-navbar";
import { SeoHead } from "@/components/seo-head";

const SUPPORT_EMAIL = "support@todollm.com";

export function ContactPage() {
  return (
    <div className="min-h-screen bg-background">
      <SeoHead
        title="Contact Support"
        description="Get help with TodoLLM. Reach our team by email - we answer most messages within one business day."
        canonical="https://todollm.com/contact"
      />
      <PublicNavbar />
      <main className="mx-auto max-w-3xl px-6 py-16">
        <header className="mb-8 space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary">
            Contact
          </p>
          <h1 className="text-3xl font-bold tracking-tight">Get in touch</h1>
          <p className="text-sm text-muted-foreground">
            Question about billing, your account, or how something works? Reach
            out.
          </p>
        </header>

        <Card>
          <CardHeader>
            <CardTitle>Email support</CardTitle>
            <CardDescription>
              We answer most messages within one business day.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button asChild>
              <a href={`mailto:${SUPPORT_EMAIL}`}>
                <Mail className="size-4" />
                {SUPPORT_EMAIL}
              </a>
            </Button>
            <p className="text-sm text-muted-foreground">
              Already have a question covered in our docs? Check the{" "}
              <Link
                to="/faq"
                className="font-medium text-foreground underline-offset-4 hover:underline"
              >
                FAQ
              </Link>{" "}
              first.
            </p>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
